import React from 'react';

import {Group} from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';

import {
    headlineHeaderSeparator,
    headlineSubHeader,
    headlineTitle,
} from './headline.module.styl';


type Props = {
    header: React.ReactNode,
    subHeader?: React.ReactNode,
    prefix?: React.ReactNode,
    actionButtons?: React.ReactNode,
};

export const Headline: React.FC<Props> = ({header, subHeader, actionButtons, prefix}) => (
    <div className={headlineTitle}>
        <Group alignItems="center">
            {prefix}
            <Typography variant="heading-level-1">
                {header}
            </Typography>
            {subHeader ? <span className={headlineHeaderSeparator}/> : null}
            {subHeader ? (
                <Group gap="s" className={headlineSubHeader}>
                    {subHeader}
                </Group>
            ) : null}
        </Group>
        {actionButtons ? (
            <Group alignItems="center">
                {actionButtons}
            </Group>
        ) : null}
    </div>
);
